module.exports = __webpack_public_path__ + "assets/04c2d0dee06e25006d77f08091b5e05d.mp4";